import React, { Fragment, useState } from 'react';
// Material UI
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    cursor: 'pointer',
    height: 48,
  },
}));

export default function LogImg({ value }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  return value ? (
    <Fragment>
      <Dialog
        className={classes.dialog}
        onClose={() => setOpen(false)}
        open={open}
      >
        <img alt="" src={value} />
      </Dialog>
      <img
        className={classes.root}
        onClick={() => setOpen(true)}
        src={value}
        alt=""
      />
    </Fragment>
  ) : (
    'No disponible'
  );
}
